var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1716_1896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57.6337,
    height: 54,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1716_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9262 75.6843C57.7288 75.6843 81.0777 54.0513 81.0777 27.3656C81.0777 0.679856 57.7288 -20.9531 28.9262 -20.9531C0.123673 -20.9531 -23.2253 0.679856 -23.2253 27.3656C-23.2253 54.0513 0.123673 75.6843 28.9262 75.6843Z",
    fill: "url(#paint0_linear_1716_1896)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5287 23.0245H21.672V38.6856H16.5287V23.0245ZM19.0376 15.3125C20.6684 15.3125 22.0483 16.6176 22.0483 18.16C22.0483 19.7024 20.6684 21.0075 19.0376 21.0075C17.4068 21.0075 16.0269 19.7024 16.0269 18.16C16.1523 16.6176 17.4068 15.3125 19.0376 15.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6319 22.9285H29.8737V25.0778H30.0081C30.6802 23.8837 32.5619 22.5703 35.25 22.5703C40.7607 22.5703 41.836 25.7942 41.836 30.0927V38.6897H36.3253V31.0479C36.3253 29.2569 36.3253 26.8688 33.5027 26.8688C30.6802 26.8688 30.1426 28.8987 30.1426 30.9285V38.6897H24.6319V22.9285Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1716_1896",
    x1: -7.93023,
    y1: -6.78661,
    x2: 60.2943,
    y2: 66.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.ea343d4ea220b4e137dbd3604d8b05d9.svg";
export { ForwardRef as ReactComponent };